import { Button, Grid, Message } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={1}>

			<Message
				titleText="Warning message content"
				variant="warning"
			/>
			<Message
				bulletPoints={["Warning message content", "Warning message content", "Warning message content"]}
				titleText="Title for Warning Message"
				variant="warning"
			/>
			<Message
				description="Warning message content. Warning message content. Warning message content. Warning message content. Warning message content. Warning message content. Warning message content. Warning message content. Warning message content. Warning message content. Warning message content. Warning message content."
				titleText="Title for Warning Message"
				variant="warning"
			/>
			<Message
				titleText="Warning message content"
				variant="warning"
			>{{
					buttons: (
						<Grid
							container
							justifyContent="flex-end"
							spacing={2}
						>
							<Grid item>
								<Button design="secondary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="primary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="link">Dismiss</Button>
							</Grid>
						</Grid>
					),
				}}
			</Message>
			<Message
				bulletPoints={["Warning message content", "Warning message content", "Warning message content"]}
				titleText="Warning message content"
				variant="warning"
			>{{
					buttons: (
						<Grid
							container
							justifyContent="flex-end"
							spacing={2}
						>
							<Grid item>
								<Button design="secondary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="primary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="link">Dismiss</Button>
							</Grid>
						</Grid>
					),
				}}
			</Message>

		</CssColumnGrid>
	);
};

